import React, { useState, useEffect } from 'react'
import Container from '../../layouts/Container/Container'
import Button from '../atoms/Button'

import {
  stQuiz
} from './../../utils/helpers'
import { connect } from 'react-redux'

function TestQuestions({
  token,
  quizNumber,
  context
}) {
  const [yesOrNot, setYesOrNot] = useState(false)
  const [response, setResponse] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [ok, serOk] = useState(false)

  const respond = (str) => {
    setYesOrNot(str)
  }
  const handleQuiz = () => {
    setIsLoading(true)
    console.log("Send quiz!", yesOrNot, response)

    stQuiz(token, yesOrNot, response, quizNumber).then((res) => {
      if (res && res.statusCode === 200) {
        setYesOrNot(false)
        setResponse("")
        serOk(true)
      }
      console.log("resres", res)
      setIsLoading(false)
    }).catch(() => {
      setIsLoading(false)
    })
  }

  const dataLayerProgress = (title) => {
    console.log("dataLayerProgress", title)
    window.dataLayer.push({
      event: "survey",
      title: "¿Te parecio útil este contenido?",
      message: yesOrNot,
      site_url: window.location.href,
      text: response
    });
  }

  const handleChange = async (e) => {
    setResponse(e.target.value)
  }

  useEffect(() => {
    if (context && context.quiz && context.quiz[0]) {
      // serOk(true)
      serOk(false)
    }
  }, [context])

  return (
    <div className={`mc-test-questions`}>
      <Container>
        <h4 className={ok ? 'ok_thanks' : ''}>
          {ok
            ? '¡Gracias por tus comentarios!'
            : '¿Te pareció útil este contenido?'
          }
        </h4>
        {!ok &&
          <div className='mc-test-questions--buttons'>
            <button onClick={() =>respond('yes')} className={yesOrNot === 'yes' ? 'active' : ''}>Sí</button>
            <button onClick={() =>respond('no')} className={yesOrNot === 'no' ? 'active' : ''}>No</button>
          </div>
        }
        {!ok &&
        <div className={`mc-test-questions--details slow_ani ${yesOrNot ? 'active' : 'active'} ${isLoading ? 'loading' : ''}`}>
          {!ok &&
          <p>
            {
              yesOrNot === 'yes'
                ? 'Cuéntanos, ¿qué otra información esperas encontrar?'
                : 'Cuéntanos, ¿cómo podemos mejorar?'
            }
          </p>
          } 
          {!ok &&
          <textarea onChange={handleChange} placeholder='Escribe tu sugerencia...'></textarea>
          }
          {!ok &&
            <Button
              type="primary"
              text="Enviar"
              loading={isLoading}
              status="active"
              onClick={() => {
                handleQuiz()
                dataLayerProgress('Enviar');
              }}
            />
          }
          
        </div>
        }
      </Container>
    </div>
  )
}

const mapState = ({ user: {token} }) => {
  return {
    token
  }
}

export default connect(mapState, {})(TestQuestions)